import { ProfileInteface } from "../models/ProfileInterface";
import { UserInterface } from "../models/UserInterface";
import {getBuildDate, getScreenSize} from "./commonHelpers";

const PAGEVIEW_EVENT = "pageview";
const PAGE_TYPE = 'content';

interface AnalyticsWindow {
    digitalDataAC?: any;
}

export interface PageHierarchyLevels {
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
}

export interface Pilot {
    seniority?: string | null;
    position?: string | null;
    base?: string | null;
}

export interface ACWindow extends AnalyticsWindow{}

export const registerSiteInfo = (state: string, pilot: Pilot) => {

    window.digitalDataAC.events.push({
        "attributes": {
            "siteInfo": {
                "buildDate": getBuildDate(),
                "environment": "my access app",
                "language": "en",
                "name": "my access app",
                "siteEdition": "ca",
                "type": "responsive",
                "viewportSize": getScreenSize(),
                "webProperty": "my access app"
            },
            "userInfo": {
                "authState": state,
                "pilot": getPilot(pilot)
            }
        }
    });

};

export const pushSiteInfo = (user: UserInterface | null, profile: ProfileInteface | null) => {

    let pushFlag = true;
    window.digitalDataAC.events.forEach(event => {
        if(event.attributes && event.attributes.siteInfo && event.attributes.userInfo){
            pushFlag = false;
        }
    })

    if (pushFlag) {
        if (user && profile) {
            registerSiteInfo('logged-in', {
                'seniority': null,
                'position': profile.results?.position,
                'base': profile.results?.baseLocation
            });
        } else {
            registerSiteInfo('logged-out', {
                'seniority': null,
                'position': null,
                'base': null
            });
        }
    }
}

export const registerPageInfo = (pageName: string, levels: PageHierarchyLevels) => {
    window.digitalDataAC.events.push({
            "eventInfo": {
                "eventName": "myaccessapp-track-pageview",
                "event": PAGEVIEW_EVENT,
                "timeStamp": new Date ()
            },
            "attributes": {
                "metaDataInfo": {
                "htmlPageCodeStatus": '200'
            },
            "pageInfo": {
                "accessibility": 'true',
                "fullUrl": window.document.location!.href,
                "pageHierarchy": getPageHierarchy(levels),
                "pageName": pageName,
                "pageTitle": (window.document.title).toLowerCase(),
                "pageType": PAGE_TYPE,
                "timeStamp": new Date(),
                "url": window.document.location!.origin  + window.document.location!.pathname
            }
        }
    });
}

export const popupView = (popupName: String) => {
    window.digitalDataAC.events.push({
        "eventInfo": {
            "eventName": "myaccessapp-track-lightbox",
            "timeStamp": new Date()
        },
        "attributes": {}
    });
}


function getPageHierarchy(levels: PageHierarchyLevels) {
    return {
        level1: levels.level1 || null,
        level2: levels.level2 || null,
        level3: levels.level3 || null,
        level4: levels.level4 || null
    };
}

function getPilot(pilot: Pilot) {
    return {
        seniority: pilot.seniority || null,
        position: pilot.position || null,
        base: pilot.base || null
    }
}
